import { styled } from '@mui/material';
import React from 'react';

interface FrameProps {
  height?: number;
}

const Frame = styled('div')(({ height }: FrameProps) => ({
  '&::before': {
    borderRadius: '50px',
    content: '""',
    margin: '5.5% auto 0',
    left: 0,
    right: 0,
    top: 0,
    width: '20%',
    height: '1%',
    boxShadow: 'inset 0 0 3px 1px rgba(0, 0, 0, .12)',
    display: 'block',
    position: 'absolute',
    background: '#fff',
  },
  borderRadius: '20px',
  position: 'relative',
  height: height ? height : 650,
  maxWidth: 300,
  width: '100%',
  overflow: 'hidden',
  boxSizing: 'border-box',
  background: '#fff',
  padding: '4% 1%',
  boxShadow:
    'inset 0 4px 7px 1px #fff, inset 0 -5px 20px rgba(173, 186, 204, .25), 0 2px 6px rgba(0, 21, 64, .14), 0 10px 20px rgba(0, 21, 64, .05)',
  '&::after': {
    borderRadius: '50%',
    margin: '0 auto 2%',
    content: '""',
    left: 0,
    right: 0,
    bottom: 0,
    width: '10%',
    height: 0,
    display: 'block',
    position: 'absolute',
    background: '#fff',
    paddingTop: '10%',
    boxShadow: 'inset 0 0 3px 1px rgba(0, 0, 0, .12)',
  },
}));

interface PhoneFrameProps {
  children: React.ReactNode;
  height?: number;
}

function PhoneFrame(props: PhoneFrameProps) {
  const { children, height } = props;
  return <Frame height={height}>{children}</Frame>;
}

export { PhoneFrame };
